import cn from 'classnames'
import { Typography, TYPOGRAPHY_WEIGHT } from 'components/Typography'
import { TFieldWithLabel } from './types'
import './styles.scss'
import { Tooltip } from '../Tooltip/Tooltip'
import { ReactComponent as Information } from 'assets/svg/Information.svg'
import { Popover } from 'antd'

export const FieldWithLabel = ({
  title,
  className,
  children,
  infoTooltipText,
  labelPopoverContent,
  requiredSign
}: TFieldWithLabel) =>
  children ? (
    <div className={cn('field-with-label', className)}>
      <div className="flex row">
        <Popover content={labelPopoverContent ?? null} placement="bottomRight">
          <span
            className={cn('field-with-label__label-popover-target', {
              'mr-4': infoTooltipText?.length
            })}
          >
            <Typography.Label
              weight={TYPOGRAPHY_WEIGHT.SEMI_BOLD}
              className={cn({
                'gap-8 align-center flex row': !!labelPopoverContent,
                'required-sign': requiredSign
              })}
            >
              <div>{title}</div>
              {!!labelPopoverContent && <Information />}
            </Typography.Label>
          </span>
        </Popover>
        {!!infoTooltipText?.length && (
          <Tooltip title={<div>{infoTooltipText}</div>}>
            <Information />
          </Tooltip>
        )}
      </div>
      <Typography.Body1>{children}</Typography.Body1>
    </div>
  ) : (
    <></>
  )
